export default {
  title: 'Restaurantes de prueba',
  description:
    'Cada socio puede marcar un restaurante como su restaurante de prueba. Funciona como cualquier otro restaurante y nunca se factura. Se envía una alerta de Slack cuando sus ventas del mes superan el umbral.',
  empty: 'Ningún socio tiene un restaurante de prueba.',
  columns: {
    partner: 'Socio',
    restaurant: 'Restaurante',
    designated: 'Marcado como prueba',
    gmv: 'GMV de este mes',
  },
  statuses: {
    live: 'En vivo',
    paused: 'Sin conexión',
    suspended: 'Suspendido',
  },
  gmv: {
    converted: '≈ {{amount}}',
    no_rate: 'No hay tipo de cambio guardado',
  },
  actions: {
    remove: 'Quitar designación de prueba',
  },
  toasts: {
    load_error: 'No se pudieron cargar los restaurantes de prueba.',
  },
};
